import {observer} from 'mobx-react-lite'
import React from 'react'
import {useFileViewerStore} from '../file-viewer-store'
import {usePagination} from '../utils/use-paginator'
import {Next, Prev} from './controls'
import {Preview} from './preview'

export const Pagination = observer(() => {
  const [state] = useFileViewerStore()
  const paginationRange = usePagination({
    currentPage: state.currentFileIndex,
    totalCount: state.files.length,
    siblingCount: 3
  })

  if (state.currentFileIndex === 0 && paginationRange.length < 2) {
    return null
  }

  const lastPage = paginationRange[paginationRange.length - 1]

  return (
    <>
      <Prev />
      {paginationRange.map(pageNumber => {
        return (
          <Preview
            key={pageNumber}
            pageNumber={pageNumber}
            file={state.files[pageNumber]}
          />
        )
      })}
      <Next lastPage={lastPage} />
    </>
  )
})
